<template>
	<section class="page">
		<el-tabs v-model="activeName">
			<el-tab-pane label="门店管理" name="list">
				<div class="content-box">
					<div class="operator">
						<div class="operator-col">
							<el-button size="mini" type="primary" @click="handleCreate()" v-loading="loadings.create">新建</el-button>
						</div>
					</div>
					<curd-table
						ref="listTable"
						:data-model="editorDataModel"
						:fields="tableFields"
						@doedit="handleEdit($event)"
						:search-filter="filterTableSearch"
						:sort-by="{sortKey: 'first',sortOrder: 'asc'}"
					></curd-table>
					<div class="tips">
						<a href="https://lbs.qq.com/tool/getpoint/index.html" target="_blank">获取地址坐标</a>
					</div>
				</div>
			</el-tab-pane>
		</el-tabs>

		<editor
			:show.sync="editorVisible"
			:data-model-name="editorDataModel"
			:record-id="editorId"
			:fields="editorFields"
			@change="refreshTable('listTable')"
			v-if="editorVisible"
		></editor>
	</section>
</template>

<script>
import CurdPage from "@/mixins/CurdPage.js";
import Filters from "@/mixins/Filters.js";

export default {
	mixins: [CurdPage, Filters],

	data() {
		return {
			editorDataModel: "Store",
			tableFields: [
				{
					name: "name",
					sortable: "custom",
				},
				{
					name: "address",
					sortable: false,
				},
				{
					name: "tel",
					sortable: false,
				},
				{
					name: "scope",
					sortable: false,
				},
			],
			editorFields: [
				{
					name: "name",
					rules: ["required"],
					width: "100%",
					col: 6,
				},
				{
					name: "primary_img",
					rules: ["required"],
					width: "100%",
					col: 6,
				},
				{
					name: "address",
					width: "100%",
				},
				{
					name: "open_time",
					rules: ["required"],
					width: "100%",
					col: 6,
				},
				{
					name: "tel",
					rules: ["required"],
					width: "100%",
					col: 6,
				},
				{
					name: "latitude",
					rules: ["required"],
					width: "100%",
					col: 6,
				},
				{
					name: "longitude",
					rules: ["required"],
					width: "100%",
					col: 6,
				},
				{
					name: "scope",
					rules: ["required"],
					width: "100%",
					col: 6,
					tips: "单位：公里",
				},
				{
					name: "is_hidden",
					width: "100%",
					col: 6,
				},
			],
		};
	},
};
</script>
<style lang="scss" scoped>
</style>
